import { Helmet } from 'react-helmet-async';
import { METADATA } from '../common/utils/metadata';
import './BlogPage.css';
import { useState, useEffect } from 'react';
import { fetchBlogPostSummaries } from './BlogPage.service';
import { BlogPostSummary } from './BlogPage.utils';
import { BlogList } from './blogList/BlogList.component';
import { Footer } from '../footer/Footer.component';
import { translate } from '../../lang/utils/TranslationUtils';
import { LoadingSpinner } from '../common/loadingPage/LoadingSpinner.component';
import { ErrorPage } from '../common/errorPage/ErrorPage.component';


export const BlogPage = () => {
  const [postsSummaries, setPostsSummaries] = useState<BlogPostSummary[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const TITLE: string = translate("BLOG.TITLE");
  const SUBTITLE: string = translate("BLOG.SUBTITLE");

  useEffect(() => {
    const loadPosts = async () => {
      try {
        const data = await fetchBlogPostSummaries();
        setPostsSummaries(data);
      } catch (e) {
        const errorMessage = e instanceof Error ? e.message : 'An unknown error occurred';
        setError(errorMessage);
        console.error('Failed to fetch blog posts:', e);
      } finally {
        setLoading(false);
      }
    };

    loadPosts();
  }, []);

  if (loading) return <LoadingSpinner />;
  
  if (error) {
        return <ErrorPage
          errorNumber = {503}
          errorNameCode = {"ERROR.503_NAME"}
          messageCode = {"ERROR.503_MESSAGE"}
          metaTitle = {METADATA.ERROR_503_TITLE}
          metaDescription = {METADATA.ERROR_503_DESCRIPTION} />;
        }

  return <>
    <Helmet>
      <title>{METADATA.BLOG_TITLE}</title>
      <meta 
        name = "description" 
        content = {METADATA.BLOG_DESCRIPTION} />
    </Helmet>
    <section className = "blog__hero">
      <h1>{TITLE}</h1>
      <h2>{SUBTITLE}</h2>
    </section>
    <BlogList posts = {postsSummaries} />
    <Footer />
  </>
}